import useActionReducer from '@admin/hooks/use_action_reducer'
import * as actions from './actions'
import PropTypes from 'prop-types'
import Searchbox from './searchbox'
import reducer from './reducer'
import React from 'react'

const SearchboxContainer = (props) => {

  const [state, handlers] = useActionReducer({
    display_name: 'searchbox',
    actions,
    props,
    reducer
  })

  const mergedProps = {
    ...props,
    ...state,
    ...handlers
  }

  return <Searchbox { ...mergedProps } />

}

SearchboxContainer.propTypes = {}

export default SearchboxContainer